module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2145962"
    }
  }, [_c('b', [_vm._v("CLASSIC BLACK BEAN SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2146462"
    }
  }, [_c('b', [_c('i', [_vm._v("True to the classic, we flavor this soup with ham and dry sherry.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2147462"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes plus "), _c('br'), _vm._v(" soaking beans Cook: 2 hours 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2148262"
    }
  }, [_vm._v("3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2148562"
    }
  }, [_vm._v("3 large carrots, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2148862"
    }
  }, [_vm._v("3 medium onions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2149162"
    }
  }, [_vm._v("3 stalks celery with leaves, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2149462"
    }
  }, [_vm._v("4 garlic cloves, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2149762"
    }
  }, [_vm._v("2 bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2150462"
    }
  }, [_vm._v("½ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2151362"
    }
  }, [_vm._v("1 pound dry black beans, soaked and drained "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2151962"
    }
  }, [_vm._v("2 smoked ham hocks (1½ pounds)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2153162"
    }
  }, [_vm._v("10 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2153462"
    }
  }, [_vm._v("1 teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2153762"
    }
  }, [_vm._v("½ cup chopped fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2154762"
    }
  }, [_vm._v("3 tablespoons dry sherry")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2155062"
    }
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2155362"
    }
  }, [_vm._v("12 paper-thin lemon slices")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2155862"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart Dutch oven, heat oil over medium heat. Add carrots, onions, and celery and cook, stirring occasionally, until vegetables are tender, about 10 minutes. Add garlic, bay leaves, and thyme; cook 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2157762"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Add beans, ham hocks, water, and pepper to Dutch oven; heat to boiling over high heat. Reduce heat and simmer until beans are very tender, about 2 hours. Discard ham hocks and bay leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2159462"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Spoon one-fourth of bean mixture into blender; cover, with center part of cover removed to let steam escape, and puree until very smooth. Pour puree into bowl. Repeat with remaining mixture. Return puree to Dutch oven and stir in sherry, salt, and all but 2 tablespoons parsley. Cook 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2161962"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" To serve, ladle soup into bowls, garnish with lemon slices, and sprinkle with remaining parsley. Makes about 13 cups or 12 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2163862"
    }
  }, [_vm._v("Each serving: About 207 calories, 10g protein, 32g carbohydrate, 5g total fat (1g saturated), 2mg cholesterol, 788mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d438076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c62_r1.vue
// module id = 252
// module chunks = 0